import { CommonContext } from '@repo-level/core-front';
import { ANJOUAN_COUNTRIES } from 'modules/policies/constants';
import { useContext, useEffect } from 'react';

const SEAL_ID = '2249e234-2acc-465f-bf62-93bf3f2ab7db';
const SCRIPT_SRC = `https://${SEAL_ID}.snippet.anjcdn.org/anj-seal.js`;

declare global {
  interface Window {
    anj_2249e234_2acc_465f_bf62_93bf3f2ab7db?: {
      init: () => void;
    };
  }
}

export const AnjouanSeal = () => {
  const { currentIp } = useContext(CommonContext);
  const isAnjouanCountry = ANJOUAN_COUNTRIES.includes(
    currentIp?.countryCode ?? ''
  );

  useEffect(() => {
    if (!isAnjouanCountry) return;

    const initSeal = () => {
      window.anj_2249e234_2acc_465f_bf62_93bf3f2ab7db?.init();
    };

    if (document.querySelector(`script[src="${SCRIPT_SRC}"]`)) {
      initSeal();
      return;
    }

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = SCRIPT_SRC;
    script.onload = initSeal;
    document.head.appendChild(script);
  }, [isAnjouanCountry]);

  if (!isAnjouanCountry) return null;

  return (
    <div
      data-anj-image-size="128"
      data-anj-image-type="basic-small"
      data-anj-seal-id={SEAL_ID}
      id={`anj-${SEAL_ID}`}
    />
  );
};
